import Reveal from "../components/Reveal";
import { UserPlus, ClipboardList, CalendarClock, ListChecks, FileSignature, Receipt, MailCheck } from "lucide-react";

const STEPS = [
  { icon: UserPlus, label: "New client", note: "Capture the lead" },
  { icon: ClipboardList, label: "Onboarding", note: "Intake, forms, welcome" },
  { icon: CalendarClock, label: "Booking", note: "Discovery call scheduled" },
  { icon: ListChecks, label: "Tasks", note: "The actual work" },
  { icon: FileSignature, label: "Documents", note: "Contracts, deliverables" },
  { icon: Receipt, label: "Invoice", note: "Sent and paid" },
  { icon: MailCheck, label: "Follow-up", note: "Retain the relationship" },
];

export default function WorkflowSection() {
  return (
    <section data-testid="workflow" className="py-24 lg:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-[1fr_1fr] gap-10 lg:gap-16 items-center mb-16">
          <Reveal className="max-w-xl">
            <h2 className="font-display font-extrabold text-[32px] sm:text-[42px] leading-[1.1] tracking-[-0.02em] text-[#1A2A3A] mb-4">
              One clear path, from first hello to final invoice.
            </h2>
            <p className="text-[16px] text-[#57534E] leading-relaxed">
              Every step of your client relationship lives in one place, in the
              order it actually happens.
            </p>
          </Reveal>
          <Reveal delay={120}>
            {/* Illustrative photograph — not a customer testimonial. */}
            <img
              src="/marketing/workflow_organized.webp"
              alt="Illustrative photo of an independent professional working from an organized desk."
              loading="lazy"
              decoding="async"
              className="rounded-3xl w-full shadow-[0_25px_50px_-25px_rgba(26,42,58,0.25)]"
            />
          </Reveal>
        </div>

        <div className="relative">
          <div
            aria-hidden="true"
            className="hidden lg:block absolute top-[42px] left-[6%] right-[6%] h-[2px] bg-gradient-to-r from-transparent via-[#E8712C]/50 to-transparent"
          />
          <ol className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-6 lg:gap-4 relative">
            {STEPS.map((s, i) => (
              <Reveal key={s.label} delay={i * 60}>
                <li className="text-center">
                  <div className="mx-auto w-[84px] h-[84px] rounded-full bg-white border border-[#E8E2D9] flex items-center justify-center shadow-[0_10px_20px_-10px_rgba(26,42,58,0.15)]">
                    <s.icon size={30} strokeWidth={1.6} className="text-[#E8712C]" />
                  </div>
                  <div className="mt-4 font-display font-bold text-[15px] text-[#1A2A3A] tracking-[-0.01em]">
                    {s.label}
                  </div>
                  <div className="mt-1 text-[12px] text-[#57534E] leading-snug">{s.note}</div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
